import { Button, Checkbox, Form, Input, message, Modal, Select, Table } from "antd";
import DataTable, { DataItemAction, DataTableRef } from "../../common/components/DataTable"
import useInfraccionesInfractoresAPI, { InfraccionesInfractor } from "../../infracciones-infractores/useInfraccionesInfractoresAPI"
import { FilterValue } from "antd/lib/table/interface";
import DataFilter from "../../common/components/DataFilter";
import { useRef, useState } from "react";
import { Infraccion } from "../../infracciones/hooks/useInfraccionesAPI";
import Column from "antd/lib/table/Column";
import moment from "moment";
import ActaPreview, { ActaPreviewRef } from "../../infracciones/components/ActaPreview";
import useLotesImpresionAPI from "../../lotes-impresion/useLotesImpresionAPI";
import VideoViewer from "../../lotes-renombrado/components/VideoViewer";
import { DownloadOutlined } from "@ant-design/icons";

export default()=>{
    const apiLoteImpresion = useLotesImpresionAPI();
    const apiInfInf = useInfraccionesInfractoresAPI();    
     const [ cuitCuilFilterForm ] = Form.useForm();
     const [ nombreCompletoForm ] = Form.useForm();
     const [ selectedInfractor, setSelectedInfractor ] = useState<InfraccionesInfractor>();
     const [ loading, setLoading ] = useState<boolean>(false);
     const [ infraccionPdfUrl, setInfraccionPdfUrl ] = useState<string>();
     const tableRef = useRef<DataTableRef>(undefined!)
     const actaPreviewRef = useRef<ActaPreviewRef>(null!);
     const [ infraccionVideoUrl, setInfraccionVideoUrl ] = useState<string>('');
     const [ estadoPagoForm ] = Form.useForm();

     const generateFilters = (filters: Record<string, FilterValue | null>) => {
         return [
             filters?.InfractorCuitCuil != null ? `contains(InfractorCuitCuil,'${filters!.InfractorCuitCuil![0]}')` : "",
             filters?.InfractorNombreCompleto != null ? `contains(InfractorNombreCompleto,'${filters!.InfractorNombreCompleto![0]}')` : "",
             filters?.InfractorTipo != null ? `InfractorTipo eq '${filters!.InfractorTipo![0]}'` : "",
             filters?.EstadoPago != null && filters?.EstadoPago[0] === true ? `EstadoPago eq 'IMPAGA'` : "",
         ];
     }

     const showPdf = async (id: number) => {
        setLoading(true);
        try {            
            const response = await apiLoteImpresion.getActaPdf(id);
            setLoading(false);
            if (response.error) throw Error;
            setInfraccionPdfUrl(response.data?.value);
        }
        catch (e) {            
            message.info('No se encontro el acta');
            setLoading(false);
        }
     };

     const showVideo = async(id:number) => {
        setLoading(true);
        try {           
            let cuit = selectedInfractor?.InfractorCuitCuil || '-1'; 
            const response = await apiInfInf.listInfraccionesCuitCuilEnviadas({$expand:['Videos'], $filter: [`Id eq ${id}`]}, cuit)
            setLoading(false);
            if (response.error) throw Error;
            if (response.data?.value[0].Videos?.length == 0) message.info('No se encontro el video');
            setInfraccionVideoUrl(response.data?.value[0].Videos?.[0]?.FullUrl || '');
        }
        catch (e) {            
            message.error("Error al descargar el video");
            setLoading(false);
        }
     }

     const itemActions: DataItemAction<InfraccionesInfractor>[] = [
         {
             key: 'list-infracciones',
             action(item, selectedItems) {
                setSelectedInfractor(item)
             },
             label: "Ver infracciones"
         }
     ];

     const itemActionsInfracciones: DataItemAction<Infraccion>[] = [
        {
            key: "download",
            label: "Visualizar PDF",
            action(item) {                
                showPdf(item.Id);
            },
            checkDisabled: (selectedItems, currentIndex, items) => {
                return false;
            },
         },
         {
            key: "show-video",
            label: "Visualizar video",
            action(item) {
                showVideo(item.Id);
            }
         }
     ];

     const handleCaptureImageFromVideo = (file: File, image: any) => {
        if (file && image) {
            Modal.confirm({
                title: "Se ha tomado una captura del video",
                content: `¿Desea guardarla?`,
                maskClosable: false,
                okText: "Continuar",
                cancelText: "Cancelar",
                onOk: () => {
                    handleDownload(file);
                },
                onCancel: () => {
                    return;
                },
            });
        }
    };

    const handleDownload = async (file : File | undefined) => {
        if (file){
            const url = URL.createObjectURL(file); // Crea una URL temporal para la imagen
            const a = document.createElement('a'); // Crea un enlace temporal
            a.href = url;
            a.download = file.name || 'captura-video.png'; // Asigna el nombre del archivo (o un nombre predeterminado)
            document.body.appendChild(a); // Añade el enlace temporal al DOM
            a.click(); // Simula el clic para iniciar la descarga
            document.body.removeChild(a); // Elimina el enlace después de la descarga
            URL.revokeObjectURL(url); // Revoca la URL temporal
        }
        else{
            const response = await fetch(infraccionVideoUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
        
            const a = document.createElement('a');
            a.href = url;
            a.download = 'video-infraccion.mp4';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }
      };
 
     return (
         <>
            <ActaPreview ref = {actaPreviewRef} />


            <Modal
                width = {"90%"}
                style = {{ maxWidth: "1024px" }}
                bodyStyle = {{ height: "80vh", overflow: "auto" }}
                onCancel = { () => setInfraccionPdfUrl(undefined) }
                open = { infraccionPdfUrl !== undefined} footer = {null} >
                { infraccionPdfUrl && <iframe style = {{ width: "100%", height: "100%" }} src = { `${infraccionPdfUrl}?timestamp=${new Date().getTime()}` } />}
            </Modal>

            <Modal
                width = {"90%"}
                style = {{ maxWidth: "1024px" }}
                bodyStyle = {{ height: "80vh", overflow: "auto" }}
                onCancel = { () => setInfraccionVideoUrl('') }
                open = { infraccionVideoUrl.length > 1} footer = {null} 
                destroyOnClose>
                <VideoViewer videoUrl={infraccionVideoUrl} onCapture={handleCaptureImageFromVideo} />
                <Button 
                    icon={<DownloadOutlined />} 
                    onClick={()=> handleDownload(undefined)} 
                    style={{ marginLeft: '10px' }} 
                    type="primary"
                >
                    Descargar Video
                </Button>
            </Modal>

             <DataTable<InfraccionesInfractor, InfraccionesInfractor>
                 list={ (query) => apiInfInf.listImpagas({ ...query } ) }
                 defaultPageSize={10}
                 generateFilters={generateFilters}
                 defaultSortOrder={"CantidadInfracciones desc"}
                 title="Infractores con infracciones adeudadas"
                 itemActions={itemActions}
                 ref={tableRef}
                 scroll={1500}
             >                
                 <Table.Column<InfraccionesInfractor>
                     width={`35%`}
                     title="Nombre completo"
                     dataIndex={"InfractorNombreCompleto"}
                     filterDropdown={(props) => {
                         return (
                             <DataFilter filterDropdownProps={props} form={nombreCompletoForm} >
                                 <Form.Item name={"NombreCompleto"} style={{ marginBottom: 10 }}>
                                     <Input placeholder='Nombre completo...'></Input>
                                 </Form.Item>
                             </DataFilter>
                         );
                     }}
                     sorter
                     render={(val, record) => record.InfractorNombreCompleto}
                     sortDirections={["ascend", "descend", "ascend"]}
 
                 />
 
                 <Table.Column<InfraccionesInfractor>
                     width={`15%`}
                     title="CUIT/CUIL"
                     dataIndex={"InfractorCuitCuil"}
                     filterDropdown={(props) => {
                         return (
                             <DataFilter filterDropdownProps={props} form={cuitCuilFilterForm} >
                                 <Form.Item name={"CuitCuil"} style={{ marginBottom: 10 }}>
                                     <Input placeholder='CUIT/CUIL...'></Input>
                                 </Form.Item>
                             </DataFilter>
                         );
                     }}
                     sorter
                     render={(val, record) => record.InfractorCuitCuil}
                     sortDirections={["ascend", "descend", "ascend"]}
 
                 />
 
                 <Table.Column<InfraccionesInfractor>
                     width={`10%`}
                     title="Tipo"
                     dataIndex={"InfractorTipo"}
                     sorter
                     render={(val, record) => record.InfractorTipo}
                     filterDropdown={(props) => {
                         return (
                             <DataFilter filterDropdownProps={props} form={cuitCuilFilterForm} >
                                 <Form.Item name={"Tipo"} style={{ marginBottom: 10 }}>
                                     <Select placeholder="Tipo de infractor...">
                                         <Select.Option key="1" value={'EMPRESA'}>Empresa</Select.Option>
                                         <Select.Option key="2" value={'MASCULINO'}>Masculino</Select.Option>
                                         <Select.Option key="3" value={'FEMENINO'}>Femenino</Select.Option>
                                         <Select.Option key="4" value={'OTRO'}>Otro</Select.Option>
                                     </Select>
                                 </Form.Item>
                             </DataFilter>
                         );
                     }}
                     sortDirections={["ascend", "descend", "ascend"]} />
 
 
                 <Table.Column<InfraccionesInfractor>
                     width={`10%`}
                     title="Impagas"
                     dataIndex={"CantidadInfracciones"}
                     sorter
                     defaultSortOrder={"descend"}
                     render={(val, record) => record.CantidadInfracciones}
                     sortDirections={["ascend", "descend", "ascend"]}
 
                 />
                  <Column<InfraccionesInfractor>
                     width={`10%`}
                     title="Tel. Fijo"
                     dataIndex={"TelefonosFijos"}
                     sorter
                     render={(val, record) => {
                       
                        let data = JSON.parse(record.TelefonosFijo ?? '[]');
                        let formattedString = data.map((item: { Area: string; Telefono: string; }) => {
                            return `${item.Area ?? ''}${item.Telefono ?? ''}`;
                        }).join('\n');

                        return formattedString;
                     }}
                     sortDirections={["ascend", "descend", "ascend"]}
 
                 />
                  <Table.Column<InfraccionesInfractor>
                     width={`10%`}
                     title="Tel. Cel."
                     dataIndex={"TelefonosCelulares"}
                     sorter
                     render={(val, record) => {
                        let data = JSON.parse(record.TelefonosCelulares ?? '[]');

                        if(data.length !== 0){
                            let links = data.map((item: { CelularArea: string; CelularTelefono: string; TieneWhatsapp: string }, index: number) => {
                                let area = item.CelularArea?.startsWith('0') ? item.CelularArea.slice(1) : item.CelularArea;
                                let telefono = item.CelularTelefono?.startsWith('15') ? item.CelularTelefono.slice(2) : item.CelularTelefono;
                                
                                return (
                                    <a href={`https://wa.me/54${area ?? ''}${telefono ?? ''}`} key={index} target="_blank">
                                        {`${item.CelularArea ?? ''} ${item.CelularTelefono ?? ''} ${item.TieneWhatsapp ? '(WhatsApp)' : ''}`}
                                    </a>
                                );
                            });
    
                            return <>{links.reduce((prev: any, curr: any) => [prev, <br/>, curr])}</>;
                        }

                        return '';
                        // return record.TelefonosCelulares;
                     }}
                     sortDirections={["ascend", "descend", "ascend"]}
 
                 />
                  <Table.Column<InfraccionesInfractor>
                     width={`50%`}
                     title="Emails"
                     dataIndex={"Emails"}
                     sorter
                     render={(val, record) => {
                        let data = JSON.parse(record.Emails ?? '[]');
                        let formattedString = data.map((item: { Email: string;}) => {
                            return `${item.Email ?? ''}`;
                        }).join('\n');

                        return formattedString;
                     }}
                     sortDirections={["ascend", "descend", "ascend"]}
 
                 />
             </DataTable>
 
             <Modal
                 width={"90%"}
                 style={{ maxWidth: "1200px" }}
                 bodyStyle={{ maxHeight: "500px", overflow: "auto" }}
                 title={`Infracciones de ${selectedInfractor?.InfractorNombreCompleto} (${selectedInfractor?.InfractorCuitCuil})`}
                 open={selectedInfractor !== undefined}
                 onCancel={() => setSelectedInfractor(undefined)}
                 cancelText='Cerrar'
                 destroyOnClose
             >
                 {selectedInfractor &&
                       <DataTable<Infraccion, Infraccion>
                       list={(query) => apiInfInf.listInfraccionesCuitCuilEnviadas({ ...query, ...{} }, selectedInfractor.InfractorCuitCuil)}
                       defaultPageSize={100}
                       generateFilters={generateFilters}
                       defaultSortOrder={"Id desc"}
                       title={'Infracciones PAGAS e IMPAGAS del infractor'}
                       itemActions={itemActionsInfracciones}
                   >
                       <Table.Column<Infraccion>
                           width={`10%`}
                           title="Dominio"
                           dataIndex={"Patente"}
                           sorter
                           
                           sortDirections={["ascend", "descend", "ascend"]}
                       />
                       <Table.Column<Infraccion>
                           width={`20%`}
                           title="Fecha de infracción"
                           dataIndex={"FechaHora"}
                           sorter
                           render={(val, record) => moment(record.FechaHora).format("DD/MM/YYYY HH:mm:ss")}
                           sortDirections={["ascend", "descend", "ascend"]}
                       />
                       <Table.Column<Infraccion>
                           width={`20%`}
                           title="Fecha de impresión"
                           dataIndex={"FechaImpresionGenerada"}
                           sorter
                           render={(val, record) => moment(record.FechaImpresionGenerada).format("DD/MM/YYYY HH:mm:ss")}
                           sortDirections={["ascend", "descend", "ascend"]}
                       />
                       <Table.Column<Infraccion>
                           width={`15%`}
                           title="Fecha 1er vencimiento"
                           dataIndex={"FechaVencimiento"}
                           sorter
                           render={(val, record) => moment(record.FechaVencimiento).format("DD/MM/YYYY")}
                           sortDirections={["ascend", "descend", "ascend"]}
                       />
                       <Table.Column<Infraccion>
                           width={`15%`}
                           title="Fecha 2do vencimiento"
                           dataIndex={"Fecha2doVencimiento"}
                           sorter
                           render={(val, record) => moment(record.Fecha2doVencimiento).format("DD/MM/YYYY")}
                           sortDirections={["ascend", "descend", "ascend"]}
                       />
                       <Table.Column<Infraccion>
                           width={`15%`}
                           title="Estado de pago"
                           dataIndex={"EstadoPago"}
                           sorter
                           render={(val, record) =>
                               <span style={{ color: record.EstadoPago == 'PAGADA' ? '#388e3c' : '#e53935' }}>
                                   {record.EstadoPago}
                               </span>}
                           sortDirections={["ascend", "descend", "ascend"]}
                           filterDropdown = {(props) => {
                            return (
                              <DataFilter filterDropdownProps = { props } form = { estadoPagoForm }>                
                                <Form.Item name = {"EstadoPago"} style = {{ marginBottom: 10 }} valuePropName = "checked">
                                  <Checkbox>Impagas</Checkbox>
                                </Form.Item>
                              </DataFilter>
                            );
                          }}
                       />
                   </DataTable>}
             </Modal>
         </>
     )
}